import { createReducer } from 'redux-starter-kit';
import { setUserSummaries, putUserSummary } from './userSummaryActions';


/**
 * A selector for an user summary in the state.
 * @param {object} state The redux state of the application.
 * @param {number} userId The id of the user.
 */
export const selectUserSummary = (state, userId) => state.via.domain.userSummaries[userId];


/**
 * A dict object with a property key of: userId and a property value of the user summary object.
 */
const initialUserSummaryState = {
};

/**
 * A reducer for managing the global via searches.
 */
export default createReducer(initialUserSummaryState, {
  // Puts a single user summary into the store.
  [putUserSummary]: (state, { payload }) => ({
    ...state,
    [payload.userId]: payload,
  }),

  // Adds/replaces 1 or more user summaries in the store.
  [setUserSummaries]: (state, action) => {
    const summaries = action.payload;

    return summaries.reduce((newState, summary) => {
      newState[summary.userId] = summary; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...state });
  },
});
